import React from 'react';

const sortButtonBaseStyle = {
  width: '22px',
  height: '22px',
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  color: 'var(--text-muted)',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const getSortButtonStyle = (active) => ({
  ...sortButtonBaseStyle,
  color: active ? 'var(--primary)' : 'var(--text-muted)'
});

const SortArrowIcon = ({ descending = false }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: descending ? 'rotate(180deg)' : 'none' }}
    aria-hidden="true"
  >
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

const SortableHeader = ({ label, sortKey, sort, onSortChange, style }) => {
  const isActive = sort.sortBy === sortKey;
  const nextSortOrder = isActive && sort.sortOrder === 'asc' ? 'desc' : 'asc';
  const isDescending = isActive && sort.sortOrder === 'desc';
  const nextSortLabel = nextSortOrder === 'asc' ? 'ascending' : 'descending';

  return (
    <th style={style}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', whiteSpace: 'nowrap' }}>
        <span>{label}</span>
        <button
          type="button"
          style={getSortButtonStyle(isActive)}
          onClick={() => onSortChange(sortKey, nextSortOrder)}
          aria-label={`Sort ${label} ${nextSortLabel}`}
          aria-pressed={isActive}
          title={`Sort ${label} ${nextSortLabel}`}
        >
          <SortArrowIcon descending={isDescending} />
        </button>
      </div>
    </th>
  );
};

export default SortableHeader;
